var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOutlineMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5195 8.75C18.5195 8.0625 17.9345 7.5 17.2195 7.5H6.81953C6.10453 7.5 5.51953 8.0625 5.51953 8.75V16.25C5.51953 16.9375 6.10453 17.5 6.81953 17.5H17.2195C17.9345 17.5 18.5195 16.9375 18.5195 16.25V8.75ZM17.2195 8.75L12.0195 11.8687L6.81953 8.75H17.2195ZM17.2195 16.25H6.81953V10L12.0195 13.125L17.2195 10V16.25Z",
    fill: "#002037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineMail);
export default __webpack_public_path__ + "static/media/ic_outline-mail.659b0e86446173ac559d6a4c93ecaeeb.svg";
export { ForwardRef as ReactComponent };